export enum AuthorizationEnum {
  ADMINISTRATOR = 1,
  OPERATIVE = 4,
  STORER = 0,
  DRIVER = 2,
  HOST_CLIENT = 3,
  SUPER_ADMIN = 5
}
